import { render } from "./RichOfferContent.vue?vue&type=template&id=bb0210cc&scoped=true"
import script from "./RichOfferContent.vue?vue&type=script&lang=js"
export * from "./RichOfferContent.vue?vue&type=script&lang=js"

import "./RichOfferContent.vue?vue&type=style&index=0&id=bb0210cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0210cc"]])

export default __exports__